
    import '/home/runner/work/iscorrect/iscorrect/src/IP/index.zh-CN.md?watch=parent';
    export const toc = [];
export const frontmatter = {"title":"IP","toc":"menu","filename":"src/IP/index.zh-CN.md","lastUpdated":1724113501000,"description":"..."};